import React, { useState, useRef, useMemo, useEffect, useImperativeHandle, useCallback } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { Button, Menu, Dropdown, Tooltip } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { apis, apiHolder as api, inWindow, util } from 'api';
import classnames from 'classnames';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import { getPositionForTextArea, setCursorPosition, isMainAccount } from '../../util';
import SendErrorContect from '@web-mail-write/components/SendMail/SendErrorContect';
import './index.scss';
import { MailActions, useActions, useAppSelector } from '@web-common/state/createStore';
import { joinWebmailActivity } from '@web-common/components/util/webmail-util';
import InputContextMenu from '@web-common/components/UI/InputContextMenu/InputContextMenu';
import NoticeModal from '../ThumbUp/NoticeModal';
import { getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const QuickRespondPhraseKey = 'QuickRespondPhraseKey';
const SpecialChar = ['?', '？', ',', '，', '!', '！', ';', '；', '.', '。', ''];
const Reply = React.forwardRef(({ mid, mailContent, emoticonInfo, handleEmoticon, onExpand }, ref) => {
    var _a, _b, _c;
    const containerRef = useRef(null);
    const textRef = useRef();
    const DefaultInputText = [
        {
            text: getIn18Text('HAODE'),
            priority: 100,
        },
        {
            text: getIn18Text('SHOUDAO'),
            priority: 99,
        },
        {
            text: getIn18Text('TAIBANGLE'),
            priority: 98,
        },
        {
            text: getIn18Text('XIEXIE'),
            priority: 97,
        },
        {
            text: 'OK',
            priority: 96,
        },
        {
            text: getIn18Text('XINKULE'),
            priority: 95,
        },
        {
            text: getIn18Text('HEZUOYUKUAI'),
            priority: 94,
        },
        {
            text: getIn18Text('TONGYI'),
            priority: 93,
        },
    ];
    const [inputText, setInputText] = useState([]);
    const [startCursor, setStartCursor] = useState(0);
    const [content, setContent] = useState('');
    const [currentMail, setCurrentMail] = useState();
    const { doReplyChangeExpanded: setIsExpandId } = useActions(MailActions);
    const replyExpandedId = useAppSelector(state => state.mailReducer.replyExpandedId);
    const [isReplyAll, setIsReplyAll] = useState(true);
    const [contactText, setContactText] = useState('');
    const [receiverNum, setReceiverNum] = useState();
    const systemApi = api.api.getSystemApi();
    const [replyBtnLoading, setReplyBtnLoading] = useState(false);
    const [visibleErrorContect, setVisibleErrorContect] = useState(false);
    const [errorMsg, setErrorMsg] = useState({});
    const receiverMemo = useMemo(() => mailContent === null || mailContent === void 0 ? void 0 : mailContent.receiver, [visibleErrorContect]);
    const currentUser = systemApi.getCurrentUser();
    const [isHasThumbUp, setIsHasThumbUp] = useState(false);
    const [locakReplyMailId, setLockReplyMailId] = useState('');
    const [noticeVisible, setNoticeVisible] = useState(false);
    const [thumbUpNotice, setThumbUpNotice] = useState(!(inWindow() && window.localStorage.getItem('thumbUpNotice')));
    const [thumbUpSend, setThumbUpSend] = useState(inWindow() && window.localStorage.getItem('thumbUpSend') === '1');
    const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const isMainAcc = useMemo(() => {
        return isMainAccount(mailContent === null || mailContent === void 0 ? void 0 : mailContent._account);
    }, [mailContent]);
    const isComposition = useRef(false);
    useEffect(() => {
        try {
            const _inputTextString = window.localStorage.getItem(QuickRespondPhraseKey);
            const _inputText = JSON.parse(_inputTextString);
            if (Array.isArray(_inputText)) {
                setInputText(_inputText);
            }
            else {
                setInputText(DefaultInputText);
                window.localStorage.setItem(QuickRespondPhraseKey, JSON.stringify(DefaultInputText));
            }
        }
        catch (error) {
            setInputText(DefaultInputText);
        }
    }, [mid]);
    useEffect(() => {
        var _a;
        try {
            const hasThumbUp = (_a = emoticonInfo === null || emoticonInfo === void 0 ? void 0 : emoticonInfo.involvedRecords) === null || _a === void 0 ? void 0 : _a.filter(item => item.acc_email === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id));
            setIsHasThumbUp(hasThumbUp && hasThumbUp.length > 0 ? true : false);
        }
        catch (error) {
            console.log('error');
        }
    }, [emoticonInfo]);
    useImperativeHandle(ref, () => ({
        update: () => {
            setIsExpandId('');
        },
    }));
    const changeReplyAll = isAll => {
        message.success({
            content: `已切为“回复${isAll ? getIn18Text('QUANBU') : ''}”`,
        });
        setIsReplyAll(isAll);
    };
    const getRenderDom = React.useCallback(() => containerRef.current || document.body, [containerRef.current]);
    const menu = () => (React.createElement(Menu, { selectedKeys: [isReplyAll ? '2' : '1'], className: "u-reply-tooltip-menu" },
        React.createElement(Menu.Item, { key: "1", onClick: () => {
                changeReplyAll(false);
            } },
            React.createElement("span", { className: "u-reply" },
                React.createElement(ReadListIcons.ReplySvgCof, { color: isReplyAll ? '#262A33' : '#386EE7' })),
            React.createElement("span", { className: "u-status-menu-text menu", style: { color: isReplyAll ? '#262A33' : '#386EE7' } }, getIn18Text('HUIFU'))),
        React.createElement(Menu.Item, { key: "2", onClick: () => changeReplyAll(true) },
            React.createElement("span", { className: "u-reply" },
                React.createElement(ReadListIcons.ReplyAllSvgCof, { color: isReplyAll ? '#386EE7' : '#262A33' })),
            React.createElement("span", { className: "u-status-menu-text menu", style: { color: isReplyAll ? '#386EE7' : '#262A33' } }, getIn18Text('HUIFUQUANBU')))));
    const onInputChange = e => {
        const position = getPositionForTextArea(textRef.current);
        setStartCursor(position.start);
        if (!isComposition.current) {
            setContent(e.target.value);
        }
    };
    const onInputText = (item) => {
        const position = getPositionForTextArea(textRef.current);
        const cursorBeforeChar = content[position.start - 1] || '';
        const _item = SpecialChar.includes(cursorBeforeChar) ? item : `，${item}`;
        const str = (content === null || content === void 0 ? void 0 : content.substring(0, position.start)) + _item + (content === null || content === void 0 ? void 0 : content.substring(position.start, content.length));
        setContent(str);
        setStartCursor(str === null || str === void 0 ? void 0 : str.length);
        setIsExpandId(mid);
    };
    const handlePriorityChange = (text) => {
        try {
            const phrasesString = window.localStorage.getItem(QuickRespondPhraseKey);
            const phrases = JSON.parse(phrasesString);
            const targetIndex = phrases.findIndex(item => item.text === text);
            phrases[targetIndex].priority = Date.now();
            window.localStorage.setItem(QuickRespondPhraseKey, JSON.stringify(phrases));
        }
        catch (error) {
        }
    };
    const saveTempText = () => {
        mailApi.doSaveMailInitParamLocal(Object.assign(Object.assign({}, currentMail), { originContent: content, _account: mailContent === null || mailContent === void 0 ? void 0 : mailContent._account }));
    };
    const delTempText = () => {
        mailApi.doDelMailInitParamLocal(Object.assign(Object.assign({}, currentMail), { originContent: content, _account: mailContent === null || mailContent === void 0 ? void 0 : mailContent._account }));
    };
    const onInputBlur = () => {
        saveTempText();
    };
    const replyMail = async () => {
        setReplyBtnLoading(true);
        const param = await mailApi.doReplayMail(mid, isReplyAll, true, content, mailContent === null || mailContent === void 0 ? void 0 : mailContent._account);
        mailApi
            .doFastSend(param)
            .then(({ errMsg, entry }) => {
            if (errMsg) {
                setErrorMsg(errMsg);
                setVisibleErrorContect(true);
                return;
            }
            const { tid = '' } = entry;
            joinWebmailActivity(tid);
            message.success({
                content: getIn18Text('FASONGCHENGGONG'),
            });
            delTempText();
            setContent('');
            setIsExpandId('');
        })
            .finally(() => {
            setTimeout(() => {
                setReplyBtnLoading(false);
            }, 1000);
        });
    };
    const handleReward = () => {
        mailApi.doForwardMail(mid, { _account: mailContent === null || mailContent === void 0 ? void 0 : mailContent._account });
    };
    const closeSendMailModal = async (isNotice, isSend) => {
        setNoticeVisible(false);
        if (isNotice) {
            setThumbUpNotice(false);
            inWindow() && window.localStorage.setItem('thumbUpNotice', '1');
            setThumbUpSend(isSend);
            inWindow() && window.localStorage.setItem('thumbUpSend', isSend ? '1' : '0');
        }
        if (isSend) {
            replyExternalMail();
        }
    };
    const replyExternalMail = async () => {
        const { errMsg } = await mailApi.replyExternalThumbMail(mid, false, true, undefined, mailContent === null || mailContent === void 0 ? void 0 : mailContent._account);
        if (errMsg) {
            return;
        }
        message.success({
            content: getIn18Text('DIANZANYOUJIANYI'),
        });
    };
    const changeThumbState = () => {
        var _a, _b, _c, _d, _e, _f;
        let params = {
            email_tid: ((_a = mailContent === null || mailContent === void 0 ? void 0 : mailContent.entry) === null || _a === void 0 ? void 0 : _a.tid) || '',
            email_mid: mailContent === null || mailContent === void 0 ? void 0 : mailContent.id,
            type: 1,
            participated: !(emoticonInfo === null || emoticonInfo === void 0 ? void 0 : emoticonInfo.participated),
            email_title: ((_b = mailContent === null || mailContent === void 0 ? void 0 : mailContent.entry) === null || _b === void 0 ? void 0 : _b.title) || getIn18Text('WUZHUTI'),
            sender_email: (_e = (_d = (_c = mailContent === null || mailContent === void 0 ? void 0 : mailContent.sender) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.accountName,
            sender_mid: (_f = mailContent === null || mailContent === void 0 ? void 0 : mailContent.entry) === null || _f === void 0 ? void 0 : _f.sentMailId,
            _account: mailContent === null || mailContent === void 0 ? void 0 : mailContent._account,
        };
        !(emoticonInfo === null || emoticonInfo === void 0 ? void 0 : emoticonInfo.participated) ? trackApi.track('pcMail_click_likeMail') : trackApi.track('pcMail_click_cancelLikeMail');
        mailApi.setThumbUpCreate(params).then(data => {
            handleEmoticon(data, params.email_mid);
            if (data && !data.sender_is_internal && (data === null || data === void 0 ? void 0 : data.participated) && (data === null || data === void 0 ? void 0 : data.first_participated)) {
                if (thumbUpNotice) {
                    setNoticeVisible(true);
                }
                if (thumbUpSend) {
                    replyExternalMail();
                }
            }
        });
    };
    const handleToWrite = async () => {
        setIsExpandId('');
        const param = await mailApi.doReplayMail(mid, isReplyAll, true, content, mailContent === null || mailContent === void 0 ? void 0 : mailContent._account);
        mailApi.callWriteLetterFunc(param);
    };
    const errorContectResend = errorMsg => {
        console.log('errorMsg', errorMsg);
    };
    useEffect(() => {
        if (mid && replyExpandedId == mid && textRef.current) {
            textRef.current.focus();
            setCursorPosition(textRef.current, content.length);
        }
    }, [replyExpandedId, mid]);
    const handleMailReply = async () => {
        let mail = mailApi.doLoadMailInitParamLocal(mid);
        if (!mail) {
            mail = await mailApi.doReplayMail(mid, isReplyAll, true, '', mailContent === null || mailContent === void 0 ? void 0 : mailContent._account);
        }
        setCurrentMail(mail);
        setContent(mail.originContent || '');
        mailApi.doGetReplayContentModel(mail).then(data => {
            const _id = mailContent === null || mailContent === void 0 ? void 0 : mailContent._account;
            const str = [];
            if (data.receiver) {
                data.receiver.forEach(item => {
                    var _a, _b, _c, _d;
                    if (((_b = (_a = item === null || item === void 0 ? void 0 : item.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName) !== _id) {
                        str.push((_d = (_c = item === null || item === void 0 ? void 0 : item.contact) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.contactName);
                    }
                });
                setContactText(str.join('、'));
                setReceiverNum(data === null || data === void 0 ? void 0 : data.receiver.filter(item => { var _a, _b; return ((_b = (_a = item === null || item === void 0 ? void 0 : item.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName) !== _id; }).length);
                if (data.receiver.length <= 1) {
                    setIsReplyAll(false);
                }
            }
        });
    };
    useEffect(() => {
        if (mid != locakReplyMailId) {
            setLockReplyMailId('');
        }
    }, [mid]);
    const loadMailReply = () => {
        if (mid && mid != locakReplyMailId && !util.extractPathFromCid(mid)) {
            setLockReplyMailId(mid);
            handleMailReply();
        }
    };
    const handleReplyPanelClick = useCallback(() => {
        trackApi.track('pcMail_click_quickReplyInputBox_mailDetailPage');
    }, []);
    return (React.createElement(OutsideClickHandler, { useCapture: true, onOutsideClick: e => {
            var _a;
            const targetText = (_a = e.target) === null || _a === void 0 ? void 0 : _a.innerText;
            const ignoreList = [getIn18Text('FUZHI'), getIn18Text('JIANQIE'), getIn18Text('ZHANTIE')];
            if (replyExpandedId === mid && !ignoreList.includes(targetText)) {
                setIsExpandId('');
            }
        } },
        React.createElement("div", { className: "m-reply", ref: containerRef, "data-test-id": "quick-reply-wrap" },
            React.createElement("div", { className: "u-reply-text", hidden: replyExpandedId != mid }, inputText.length > 0 &&
                inputText
                    .sort((a, b) => b.priority - a.priority)
                    .map(({ text }) => (React.createElement("span", { onClick: () => {
                        handlePriorityChange(text);
                        onInputText(text);
                    }, key: text, className: "text" }, text)))),
            React.createElement("div", { className: "u-reply-textarea", hidden: replyExpandedId != mid },
                React.createElement(InputContextMenu, { inputOutRef: textRef, changeVal: setContent },
                    React.createElement("textarea", { className: "textarea", ref: textRef, onChange: onInputChange, onBlur: onInputBlur, value: content })),
                React.createElement(Tooltip, { getPopupContainer: getRenderDom, title: getIn18Text('DAKAIWANZHENGHUI'), mouseEnterDelay: 0.3, mouseLeaveDelay: 0.15 },
                    React.createElement("div", { className: "u-reply-expand", onClick: () => handleToWrite() },
                        React.createElement(ReadListIcons.EditorSvg, null)))),
            React.createElement("div", { className: "u-reply" },
                React.createElement("div", { className: classnames(['u-reply-input', replyExpandedId === mid ? 'expand' : '']), style: {
                        maxWidth: replyExpandedId != mid
                            ? `calc(100% - ${96 - (isCorpMail ? 48 : 0)}px)`
                            : isReplyAll
                                ? `calc(100% - ${128 - (isCorpMail ? 48 : 0)}px)`
                                : `calc(100% - ${106 - (isCorpMail ? 48 : 0)}px)`,
                    } },
                    React.createElement(Dropdown, { getPopupContainer: getRenderDom, overlayClassName: "u-tree-dropmenu", overlay: menu, trigger: ['contextMenu', 'click'] },
                        React.createElement(Tooltip, { getPopupContainer: getRenderDom, title: isReplyAll ? getIn18Text('HUIFUQUANBU') : getIn18Text('HUIFU'), mouseLeaveDelay: 0.15, placement: "right", trigger: ['hover', 'click'] },
                            React.createElement("div", { className: "u-reply-menu" },
                                React.createElement("span", { className: "dark-svg-invert u-reply-menu-reply" }, isReplyAll ? React.createElement(ReadListIcons.ReplyAllSvgCof, null) : React.createElement(ReadListIcons.ReplySvgCof, null)),
                                React.createElement("span", { className: "dark-svg-invert u-reply-menu-xiala" },
                                    React.createElement(ReadListIcons.XialaSvg, null))))),
                    React.createElement("div", { className: "u-reply-content", onClick: () => {
                            setIsExpandId(mid);
                            onExpand && onExpand(mid);
                            loadMailReply();
                            handleReplyPanelClick();
                        } },
                        React.createElement("div", { className: "u-reply-content-name" }, content && replyExpandedId != mid
                            ? content
                            : `${getIn18Text('KUAIJIEHUIFU')}${isReplyAll ? getIn18Text('QUANBU') : ''}${isReplyAll && replyExpandedId != mid ? '' : `：${isReplyAll ? contactText : ((_c = (_b = (_a = mailContent === null || mailContent === void 0 ? void 0 : mailContent.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.contactName) || ''}`}`),
                        React.createElement("div", { className: "u-reply-content-more", hidden: receiverNum === undefined || receiverNum === 1 || replyExpandedId != mid || !isReplyAll }, `${getIn18Text('GONG')}${receiverNum}${getIn18Text('REN&nbs')}`)),
                    React.createElement("div", { className: "u-reply-text u-reply-text-fast", hidden: replyExpandedId == mid || !!content }, inputText.slice(0, 4).map(({ text }) => (React.createElement("span", { onClick: () => {
                            handlePriorityChange(text);
                            onInputText(text);
                        }, key: text, className: "text" }, text))))),
                React.createElement("div", { className: "u-reply-btn", hidden: replyExpandedId == mid, onClick: handleReward }, getIn18Text('ZHUANFA')),
                !isCorpMail && isMainAcc ? (React.createElement("div", { className: "dark-svg-invert u-reply-btn u-reply-btn-svg", "data-test-id": "mail-quick-reply-like-btn", hidden: replyExpandedId == mid, onClick: changeThumbState }, isHasThumbUp ? React.createElement(ReadListIcons.hasThumbUpSvg, null) : React.createElement(ReadListIcons.unThumbUpSvg, null))) : (React.createElement(React.Fragment, null)),
                !isCorpMail && isMainAcc ? (React.createElement("div", { className: "dark-svg-invert u-reply-btn-fast", "data-test-id": "mail-quick-reply-like-btn", onClick: changeThumbState, hidden: replyExpandedId != mid }, isHasThumbUp ? React.createElement(ReadListIcons.hasThumbUpSvg, null) : React.createElement(ReadListIcons.unThumbUpSvg, null))) : (React.createElement(React.Fragment, null)),
                React.createElement(Button, { "data-test-id": "mail-quick-reply-btn", type: "primary", className: "u-send-btn", loading: replyBtnLoading, onClick: replyMail, hidden: replyExpandedId != mid, disabled: !content || replyBtnLoading, style: { width: isReplyAll ? '80px' : '68px' } }, isReplyAll ? getIn18Text('HUIFUQUANBU') : getIn18Text('HUIFU')))),
        visibleErrorContect && (React.createElement(SendErrorContect, { visible: visibleErrorContect, setVisible: setVisibleErrorContect, receiver: receiverMemo, errorMsg: errorMsg, confirm: errorContectResend, hideReSend: true })),
        noticeVisible ? React.createElement(NoticeModal, { visible: noticeVisible, onClose: (isNotice, isSend) => closeSendMailModal(isNotice, isSend) }) : null));
});
export default Reply;
